export var Usertypes;
(function (Usertypes) {
    Usertypes["CUSTOMER"] = "customer";
    Usertypes["PHOENIX"] = "phoenix";
    Usertypes["AGENCY"] = "agency";
})(Usertypes || (Usertypes = {}));
export default Usertypes;
